/**
 * 针对查询字段的父类
 * 提供基本的分页查询功能
 */
export default {
    data() {
        return {
            defaultCondition: null,
            // 允许searchBar没有输入关键字的情况下搜索
            allowEmptySearch: true,
            params: {
                number: 1,
                size: 10
                // 其他一些请求相关参数都可以放在自定义params里面
            },
            items: []
        };
    },
    methods: {
        getCondition() {
            var me = this,
                condition = [],
                defaultCondition = me.defaultCondition,
                searchBar = me.$refs.searchBar,
                searchCondition = searchBar ? searchBar.getCondition() : null;
            if (defaultCondition) {
                if (Array.isArray(defaultCondition)) {
                    condition = [].concat(defaultCondition);
                } else {
                    condition.push(defaultCondition);
                }
            }
            if (searchCondition) {
                condition.push(searchCondition);
            }
            return condition;
        },
        /**
         * 查询前判断
         */
        isAllowSearch() {
            var me = this,
                searchBar = me.$refs.searchBar;
            if (searchBar && !searchBar.keyword && !me.allowEmptySearch) {
                return false;
            }
            return true;
        },
        /**
         * 查询
         * @param {*} callback 
         * @param {*} next 是否下一页
         */
        onSearch(callback, next) {
            var me = this;
            if (!me.isAllowSearch()) {
                me.items = [];
                return;
            }
            var condition = me.getCondition(),
                params = Object.assign(
                    {
                        condition: JSON.stringify(condition)
                    },
                    me.params,
                    me.extraParams
                );
            params.number = (next && me.items.length) ? params.number + 1 : 1;
            me.$loading({
                url: me.listUrl,
                params
            }).then(function (res) {
                typeof callback == 'function' && callback.call(me);
                if (res.success) {
                    var list = res.data ? res.data.list : [];
                    if (next) {
                        if (list.length) {
                            me.params.number = params.number;
                            me.items = me.items.concat(list);
                        }
                    } else {
                        me.params.number = 1;
                        me.items = list;
                    }
                } else {
                    me.$weui.topTips(res.message, 3000);
                }
            });
        },
        onSearchNext(callback) {
            this.onSearch(callback, 1);
        }
    }
}